import { render, staticRenderFns } from "./CompanySizePage.vue?vue&type=template&id=1245ceaf"
import script from "./CompanySizePage.vue?vue&type=script&lang=js"
export * from "./CompanySizePage.vue?vue&type=script&lang=js"
import style0 from "./CompanySizePage.vue?vue&type=style&index=0&id=1245ceaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports